<template lang="html">
    <div id="search" class="toolbar-search">
        <z-select v-model="filter.group_id" light v-on:input="onFilter">
            <option value="" selected disabled>Группа (все)</option>
            <option v-for="group in groups" v-bind:value="group.id" v-bind:key="('users-group-' + group.id)">{{ group.name }}</option>
        </z-select>
        <input
            class="toolbar-search__input" id="toolbar-search__input" name="toolbar-search__input" type="text" placeholder="Поиск..." autocomplete="toolbar-search__input"
            v-model="filter.search" v-on:keyup.enter="onFilter" v-bind:readonly="!focus" v-on:focus="onFocus" v-on:blur="onBlur" ref="search-input"
        ></input>
        <z-icon-button v-bind:icon="['fa', 'xmark']" rounded danger-light v-on:click="onReset"  v-bind:disabled="!hasFilter"></z-icon-button>
    </div>
</template>
<script>
    import ZIconButton from '@/components/ZIconButton.vue';
    import ZSelect     from '@/components/ZSelect.vue';
    export default {
        components: { ZIconButton, ZSelect },
        data() {
            return {
                filterDefault: {},
                filter: {
                    search: null,
                    group_id: ''
                },
                focus: false
            }
        },
        created() {
            this.filterDefault = Object.assign({}, this.filter);
            this.resolveQueryFilter();
            this.getUserGroups();
        },
        computed: {
            hasFilter() {
                return Object.values(this.filter).some(item => !!item);
            },
            groups() {
                return this.$store.state.users.groups;
            }
        },
        watch: {
            'filter.search'(val) {
                const search = val;
                setTimeout(() => {
                    if (!this.filter.search || !this.filter.search) return this.onReset();
                    if (this.filter.search == search) this.onFilter();
                }, 1000)
            }
        },        
        methods: {
            onFocus() {
                this.focus = true;
            },
            onBlur() {
                this.focus = false;
            },
            getUserGroups() {
                this.$store.dispatch('users/getUsersGroups');
            },
            resolveQueryFilter() {
                if (!this.$route.query || !this.$route.query.filter) return;
                this.filter = Object.assign({}, JSON.parse(this.$route.query.filter));
            },
            onSearchFilter() {
                if (!this.filter.search || (this.filter.search && this.filter.search.lenght < 4)) return;
                this.onFilter();
            },
            onFilter() {
                this.$router.push({
                    name:   this.$route.name,
                    params: this.$route.params,
                    query: {
                        filter: JSON.stringify(this.filter)
                    }
                });
                this.$root.$emit('reload-table', 'users');
            },
            //сброс фильтрa
            onReset() {
                this.filter = Object.assign({}, this.filter.Default);
                let query = Object.assign({}, this.$route.query);
                delete query.filter;

                this.$router.push({
                    name: this.$route.name,
                    params: this.$route.params,
                    query: Object.assign({}, query)
                });
                this.$root.$emit('reload-table', 'users');
            }
        },
    }
</script>



// WEBPACK FOOTER //
// UsersToolbar.vue?5c676b91